import { Component, Input } from '@angular/core';

export interface SimpleStackedBarChartItem {
  label: string;
  value: number;
  entity_id?: string;
  bot_name?: string | null;
  bot_visual_name?: string | null;
}

@Component({
  selector: 'app-simple-stacked-bar-chart',
  templateUrl: './simple-stacked-bar-chart.component.html',
  styleUrl: './simple-stacked-bar-chart.component.scss',
})
export class SimpleStackedBarChartComponent {
  @Input() data: SimpleStackedBarChartItem[] = [
    { label: 'Category 1', value: 40 },
    { label: 'Category 2', value: 25 },
    { label: 'Category 3', value: 20 },
    { label: 'Category 4', value: 15 },
  ];

  @Input() leftLabel: string = '';
  @Input() rightLabel: string = '';
  @Input() loading: boolean = false;
  @Input() formatValue: (value: number) => string = (v) =>
    v as unknown as string;

  maxValue = 0;

  ngOnInit(): void {
    this.setMaxValue();
  }

  ngOnChanges(): void {
    this.setMaxValue();
  }

  setMaxValue(): void {
    if (!this.data) {
      this.maxValue = 0;
      return;
    }
    this.maxValue = Math.max(...this.data.map((d) => d.value), 0);
  }

  getBarWidth(value: number): number {
    return this.maxValue ? (value / this.maxValue) * 100 : 0;
  }

  isAgentItem(item: SimpleStackedBarChartItem): boolean {
    return Boolean(item?.bot_name || item?.bot_visual_name);
  }
}
